import { SupplierCompanyMessage } from '../../../../../types/SupplierCompanyMessage';
import { GenericError } from '../../../../common/Error/GenericError';
import { useRole } from '../../../../common/hooks/useRole';
import { LoadingIndicator } from '../../../../common/LoadingIndicator/LoadingIndicator';
import { Box } from '../../../../common/ui/Box';
import { SupplierAdminSettings } from '../../../SupplierAdminSettings';
import { SupplierMessageSettings } from '../SupplierMessageSettings';
import { useSupplierSettings } from '../useSupplierSettings';

interface SupplierSettingsTabProps {
    supplier: SupplierCompanyMessage;
}

export const SupplierSettingsTab = ({ supplier }: SupplierSettingsTabProps) => {
    const role = useRole();
    const supplierId = supplier.id;

    const supplierSettingsQuery = useSupplierSettings(supplierId);

    if (supplierSettingsQuery.isPending) {
        return <LoadingIndicator />;
    }

    if (supplierSettingsQuery.isError) {
        return <GenericError />;
    }

    const settings = supplierSettingsQuery.data;

    return (
        <Box display="flex" flexDirection="column" gap={40}>
            <SupplierMessageSettings supplierSettings={settings} supplierId={supplierId} />
            {role.isSuperAdmin() ? <SupplierAdminSettings companyDetails={supplier} /> : null}
        </Box>
    );
};
